import React from "react";
import HeaderComponent from "./UI/HeaderComponent";
import FooterComponent from "./UI/FooterComponent";
import Tabs from "./UI/Tabs";
import style from "../Assets/css/dashboard_component.css";
import UPISearchComponent from "./UPISearchComponent";
import ISINSearchComponent from "./ISINSearchComponent";

const UPIComponent = () => {
  return (
    <>
      <HeaderComponent visibility={true} />
      <div style={{ justifyContent: "space-between" }}>
        <Tabs>
          <div className={style.tab1} label="UPI Search">
            <UPISearchComponent />
          </div>
          <div className="tab2" label="ISIN Search">
            <ISINSearchComponent />
          </div>
          {/* <div className="tab2" label="Attribute Search">
            <AttributeSearch />
          </div> */}
        </Tabs>
      </div>
      <FooterComponent />
    </>
  );
};

export default UPIComponent;
